import React from "react";
import ReusablePDFLayout from "../ReusablePDFLayout";
import sign from "../../../assest/LogoAndFavicon/Hrsign/Priyamvada_signature.jpg";

export const Page8 = () => {
  return (
    <ReusablePDFLayout>
      <div className="parentcls">
        <p className="para" style={{ marginBottom: "15px" }}>
          appoint such sole arbitrator. The provisions of the Arbitration and
          Conciliation Act, 1996, shall govern the proceedings. The award of the
          arbitrator shall be final and binding. The venue for such arbitration
          shall be Chennai. For all other matters the Courts at Chennai shall
          have exclusive jurisdiction.
        </p>
        <p className="para">
          Notwithstanding the above, in the event of breach of any of the terms
          herein, the Company shall be entitled to other adequate and
          appropriate legal remedies as deemed fit. This agreement shall be
          governed by the laws of India and the Courts of Chennai shall alone
          have jurisdiction.
        </p>

        <p className="bolds" style={{ margin: "20px 0" }}>
          Entire Contract:
        </p>
        <p className="para">
          The terms and conditions referred to in this letter constitute all of
          the terms and conditions of your employment and replace any prior
          understanding or contract between you and the employer.
        </p>

        <p className="para">
          The terms and conditions referred to in this contract may only be
          varied by a written contract signed by both you and Company.
        </p>

        <p className="bolds" style={{ margin: "20px 0" }}>
          Acceptance:
        </p>
        <p className="para">
          If you have any questions about the terms and conditions of
          employment, you may please contact the HR Department of the Company.
          <br />
          If you find the above terms favorable, you may please indicate your
          acceptance within Seven (07) business days of receipt of this letter
          by signing the duplicate copy of this letter and resending it back to
          the HR Department of the Company.
        </p>
        <p className="para" style={{ margin: "20px 0" }}>
          For Keel Info Solution Private Limited
        </p>
        <div >
          <img src={sign} width={"180px"} />
        </div>
        <p className="bols" style={{marginTop:"20px"}}>Name of the Signing Authority People Partner</p>
      </div>
    </ReusablePDFLayout>
  );
};
